import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

export type TExportDestinations = {
	Export_Destination_ID: number;
	Icon_Url: string;
	Exchange_Name: string;
	ConsentToShareSSNWithTM: boolean;
};

const initialState = new Array<{
	Export_Destination_ID: number;
	Icon_Url: string;
	Exchange_Name: string;
	ConsentToShareSSNWithTM: boolean;
}>();

export const { thunk: listExportDestinations, slice: listExportDestinationsSlice } = getThunkAndSlice<
	Record<string, never>,
	Array<TExportDestinations>
>({
	initialState,
	path: "/api/System/ListExportDestinations",
	cacheId: "ListExportDestinations",
});
